import React from 'react';

const STATS_TAB_DISABLED_MESSAGE = 'Coming soon';

function BioStatsToggle({ viewMode, onToggle }) {
  const statsDisabledDescriptionId = React.useId();

  return (
    <div className="bio-stats-toggle">
      <label>TABLE VIEW MODE</label>
      <div className="toggle-buttons">
        <button 
          type="button"
          className={`toggle-btn ${viewMode === 'bio' ? 'active' : ''}`}
          onClick={() => onToggle('bio')}
        >
          Bio
        </button>
        <span className="toggle-btn-tooltip" title={STATS_TAB_DISABLED_MESSAGE}>
          <button
            type="button"
            className="toggle-btn toggle-btn-disabled"
            aria-describedby={statsDisabledDescriptionId}
            disabled
          >
            Stats
          </button>
        </span>
        <span id={statsDisabledDescriptionId} className="transfer-sr-only">
          {STATS_TAB_DISABLED_MESSAGE}
        </span>
      </div>
    </div>
  );
}

export { BioStatsToggle };
